import { Article } from "./article";
import { ArticlePreview } from "./articlePreview";
import { Home } from "./home";

export const Pages = { Article, ArticlePreview, Home };
